"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            var ModulesPaneGroup = /** @class */ (function (_super) {
                __extends(ModulesPaneGroup, _super);
                function ModulesPaneGroup() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.onClick = function (event) {
                        var target = event.target;
                        if (target.parentElement && target.parentElement.children) {
                            _this.props.SetSelectedPaneItem(Array.prototype.indexOf.call(target.parentElement.children, event.target));
                        }
                        _this.props.OnHeaderClick();
                    };
                    return _this;
                }
                ModulesPaneGroup.prototype.componentDidMount = function () {
                    this.element.dynContext = { current: this };
                };
                ModulesPaneGroup.prototype.componentDidUpdate = function () {
                    this.element.dynContext = { current: this };
                };
                ModulesPaneGroup.prototype.render = function () {
                    var _this = this;
                    var expanded = false;
                    var showLabel = false;
                    var headerClasses = "modulesPane-groupHeading";
                    if (this.props.ExpandedGutter) {
                        if (this.props.Expanded) {
                            headerClasses += " modulesPane-isExpanded ChevronUp-symbol";
                        }
                        else {
                            headerClasses += " ChevronDown-symbol";
                        }
                        showLabel = true;
                        expanded = this.props.Expanded;
                    }
                    var imageContent = UI.GutterUtil.buildImageLink({ Image: this.props.Image, ImageType: this.props.ImageType, Label: this.props.Label });
                    return (React.createElement("div", { "aria-expanded": expanded, "aria-label": this.props.Label, "aria-level": 1, className: headerClasses, "data-dyn-expanded": this.props.paneIsExpanded, "data-dyn-selected": this.props.Selected, "data-dyn-title": this.props.Label, id: this.props.Id, onClick: this.onClick, onKeyDown: this.keyHandler, onMouseEnter: this.onmouseenter, ref: function (ref) { return _this.element = ref; }, role: "treeitem", tabIndex: 0 },
                        React.createElement("span", { className: "modulesPaneGroup-linkSelected" }),
                        imageContent,
                        showLabel ? this.props.Label : ""));
                };
                return ModulesPaneGroup;
            }($dyn.DynReact.GroupHeading));
            UI.ModulesPaneGroup = ModulesPaneGroup;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModulesPaneGroup.js.map
